import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import { configurationReducer } from "../../modules/configuration";
import { languageReducer } from "../../modules/language";
import { notificationReducer } from "../../modules/notification";
import { prontoSoccorsoReducer } from "../../modules/prontoSoccorso";
import { trackingReducer } from "../../modules/tracking";

// Importare eventuali altri reducers ed aggiungerli qua sotto

const applicationReducers = combineReducers({
  configuration: configurationReducer,
  language: languageReducer,
  notification: notificationReducer,
  prontoSoccorso: prontoSoccorsoReducer,
  tracking: trackingReducer,
});

export const createReducers = (whitelist) => {
  const persistConfig = {
    key: "root",
    storage: storageSession,
    whitelist: whitelist,
  };
  return persistReducer(persistConfig, applicationReducers);
};
